import React from 'react';
import './HeroAnimation.css';

const TEAL_DOT = '#9FE1CB';
const AI_AMBER = '#F2A623';
const TEAL_LINE = '#5DCAA5';

const dots = [
  { cx: 150, cy: 120, r: 7, ai: false, delay: 0 },
  { cx: 530, cy: 110, r: 8, ai: true, delay: 0.15 },
  { cx: 110, cy: 260, r: 7, ai: false, delay: 0.1 },
  { cx: 560, cy: 270, r: 7, ai: false, delay: 0.3 },
  { cx: 200, cy: 380, r: 7, ai: false, delay: 0.4 },
  { cx: 470, cy: 390, r: 7, ai: false, delay: 0.5 },
];

const lines = [
  { d: 'M150 120 L320 220', ai: false, delay: 0 },
  { d: 'M530 110 L360 220', ai: true, delay: 0.15 },
  { d: 'M110 260 L300 250', ai: false, delay: 0.1 },
  { d: 'M560 270 L380 250', ai: false, delay: 0.3 },
  { d: 'M200 380 L320 280', ai: false, delay: 0.4 },
  { d: 'M470 390 L360 280', ai: false, delay: 0.5 },
];

export const HeroAnimation = () => {
  return (
    <svg
      className="cx-hero-anim"
      viewBox="0 0 680 460"
      role="img"
      aria-labelledby="cxHeroTitle cxHeroDesc"
      data-testid="hero-animation"
    >
      <title id="cxHeroTitle">CX Sage animated hero graphic</title>
      <desc id="cxHeroDesc">
        Customer touchpoints, including one AI-assisted node, pulse and connect toward a
        central speech bubble that repeatedly resolves with a checkmark.
      </desc>

      {/* Faint static connection lines */}
      {lines.map((l, i) => (
        <path
          key={`base-${i}`}
          className="line-base"
          d={l.d}
          fill="none"
          stroke={l.ai ? AI_AMBER : TEAL_LINE}
          strokeWidth="1.5"
        />
      ))}

      {/* Animated signal pulses traveling toward the center */}
      {lines.map((l, i) => (
        <path
          key={`pulse-${i}`}
          className="line-pulse"
          d={l.d}
          pathLength="1"
          fill="none"
          stroke={l.ai ? AI_AMBER : TEAL_LINE}
          strokeWidth="2.5"
          strokeLinecap="round"
          style={{ animationDelay: `${l.delay}s` }}
        />
      ))}

      {/* Touchpoint dots */}
      {dots.map((dot, i) => (
        <circle
          key={`dot-${i}`}
          className={`dot${dot.ai ? ' ai' : ''}`}
          cx={dot.cx}
          cy={dot.cy}
          r={dot.r}
          fill={dot.ai ? AI_AMBER : TEAL_DOT}
          style={{ animationDelay: `${dot.delay}s` }}
        />
      ))}

      {/* Resolution ring */}
      <circle className="ring" cx="345" cy="225" r="60" fill="none" stroke={TEAL_LINE} strokeWidth="3" />

      {/* Central speech bubble */}
      <path
        className="bubble"
        d="M260 190 Q260 160 290 160 L400 160 Q430 160 430 190 L430 260 Q430 290 400 290 L320 290 L290 320 L295 290 L290 290 Q260 290 260 260 Z"
        fill="#0F6E56"
      />

      {/* Resolving checkmark */}
      <path
        className="check"
        d="M310 225 L340 250 L385 200"
        pathLength="1"
        fill="none"
        stroke="#E1F5EE"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HeroAnimation;
